import { createTheme } from '@mui/material';
import radius from '../radius';

const theme = createTheme({ ...radius });

const dialog = {
  MuiDialog: {
    styleOverrides: {
      root: {
        '.MuiDialogContent-root': {
          padding: 0,
          minHeight: '100%',
          display: 'flex',

          '> .MuiPaper-root': {
            height: 'auto',
            width: '100%',
          },
        },

        '.MuiDialog-paper': {
          padding: 0,
          borderRadius: theme.radius.lg,

          [theme.breakpoints.up('sm')]: {
            borderRadius: theme.radius.xl,
          },

          '&.MuiDialog-paperFullScreen': {
            borderRadius: 0,
          },
        },
      },
    },
  },
};

export default dialog;
